/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataYoutubeVideoConfigInfoRespVo } from './PageDataYoutubeVideoConfigInfoRespVo';
import {
    PageDataYoutubeVideoConfigInfoRespVoFromJSON,
    PageDataYoutubeVideoConfigInfoRespVoFromJSONTyped,
    PageDataYoutubeVideoConfigInfoRespVoToJSON,
    PageDataYoutubeVideoConfigInfoRespVoToJSONTyped,
} from './PageDataYoutubeVideoConfigInfoRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataYoutubeVideoConfigInfoRespVo
 */
export interface ResponsePageDataYoutubeVideoConfigInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataYoutubeVideoConfigInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataYoutubeVideoConfigInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataYoutubeVideoConfigInfoRespVo}
     * @memberof ResponsePageDataYoutubeVideoConfigInfoRespVo
     */
    data?: PageDataYoutubeVideoConfigInfoRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataYoutubeVideoConfigInfoRespVo interface.
 */
export function instanceOfResponsePageDataYoutubeVideoConfigInfoRespVo(value: object): value is ResponsePageDataYoutubeVideoConfigInfoRespVo {
    return true;
}

export function ResponsePageDataYoutubeVideoConfigInfoRespVoFromJSON(json: any): ResponsePageDataYoutubeVideoConfigInfoRespVo {
    return ResponsePageDataYoutubeVideoConfigInfoRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataYoutubeVideoConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataYoutubeVideoConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataYoutubeVideoConfigInfoRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataYoutubeVideoConfigInfoRespVoToJSON(json: any): ResponsePageDataYoutubeVideoConfigInfoRespVo {
    return ResponsePageDataYoutubeVideoConfigInfoRespVoToJSONTyped(json, false);
}

export function ResponsePageDataYoutubeVideoConfigInfoRespVoToJSONTyped(value?: ResponsePageDataYoutubeVideoConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataYoutubeVideoConfigInfoRespVoToJSON(value['data']),
    };
}

